import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'
import { NameMode } from '@/enum/NameMode'

const sellerNameModeDict: Array<Dictionary> = []

for (const code of [NameMode.none, NameMode.legalName, NameMode.storeName, NameMode.custom]) {
    sellerNameModeDict.push({
        code: code,
        name: i18n.t(`dictionary.sellerNameMode.${code}`).toString()
    })
}

export { sellerNameModeDict }
